import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Container, Button } from '@mui/material';

import { IExpense } from "../../../types/expense";

import { useListContext } from "../../../contexts/listContext";
import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import ExpenseEditForm from "../../forms/expenseEditForm";
import { Icons } from "../../icons";
import dayjs from "dayjs";

const ExpenseAdd = () => {
	const userContext = useUserContext();
	const listContext = useListContext();

	const [formFields, setFormFields] = useState<IExpense>({
		id: undefined,
		name: "",
		category: "",
		spreadAcrossMaterials: false,
		isActive: true,
	});

	const reset = async () => {
		setFormFields({
			id: undefined,
			name: "",
			category: "",
			spreadAcrossMaterials: false,
			isActive: true,
		});
	}

	return (
		<div className="hwi-expense-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageExpenses}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/expense">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Expense
						</div>
					</section>
					<section className="management-page-form">
						<ExpenseEditForm action="add" expense={formFields} reloadData={reset} ></ExpenseEditForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default ExpenseAdd;